var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecordTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2788 1.89667C10.9859 1.60378 10.5111 1.60378 10.2182 1.89667C9.92528 2.18957 9.92528 2.66444 10.2182 2.95733L11.5166 4.25578C11.5796 4.31878 11.535 4.42649 11.4459 4.42649L5.24952 4.42649C4.83531 4.42649 4.49952 4.76228 4.49952 5.17649C4.49952 5.5907 4.83531 5.92649 5.24952 5.92649L11.4459 5.92649C11.535 5.92649 11.5796 6.0342 11.5166 6.0972L10.2182 7.39565C9.92528 7.68854 9.92528 8.16342 10.2182 8.45631C10.5111 8.7492 10.9859 8.7492 11.2788 8.45631L14.0283 5.70682C14.169 5.56617 14.248 5.3754 14.248 5.17649C14.248 4.97758 14.169 4.78681 14.0283 4.64616L11.2788 1.89667ZM5.77982 8.45589C6.07271 8.163 6.07271 7.68812 5.77982 7.39523C5.48692 7.10234 5.01205 7.10234 4.71916 7.39523L1.96967 10.1447C1.67678 10.4376 1.67678 10.9125 1.96967 11.2054L4.71916 13.9549C5.01205 14.2478 5.48693 14.2478 5.77982 13.9549C6.07271 13.662 6.07271 13.1871 5.77982 12.8942L4.48137 11.5958C4.41837 11.5328 4.46299 11.425 4.55208 11.425H10.7485C11.1627 11.425 11.4985 11.0893 11.4985 10.675C11.4985 10.2608 11.1627 9.92505 10.7485 9.92505H4.55208C4.46299 9.92505 4.41837 9.81733 4.48137 9.75434L5.77982 8.45589Z",
    fill: "#484B53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordTransferIcon);
export default __webpack_public_path__ + "static/media/record-transfer-icon.72f97956efe22af2935cec21db28ecc8.svg";
export { ForwardRef as ReactComponent };